import React, { Component } from 'react'
import uniqueId from 'lodash/uniqueId'

class Fire extends Component {
  static defaultProps = {
    noStreak: false,
    pathProps: {},
    svgProps: {},
  }

  state = {
    id: uniqueId('fire-linear-gradient'),
  }

  getFireColors = (noStreak, lastCompleted) =>
    noStreak ? ['#ebeef0', '#ebeef0'] : lastCompleted ? ['#FFF', '#FFF'] : ['#FF7F00', '#FFAB00']

  render() {
    const { pathProps, svgProps, noStreak, lastCompleted } = this.props
    const { id } = this.state
    const fireColors = this.getFireColors(noStreak, lastCompleted)
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 41.3" enableBackground="new 0 0 30 41.3" {...svgProps}>
        <linearGradient
          id={id}
          gradientUnits="userSpaceOnUse"
          x1="-591.3748"
          y1="356.691"
          x2="-591.3748"
          y2="352.9772"
          gradientTransform="matrix(8 0 0 -11 4745.9863 3924)"
        >
          <stop offset="0" stopColor={fireColors[0]} />
          <stop offset="1" stopColor={fireColors[1]} />
        </linearGradient>
        <path
          fill={`url(#${id})`}
          d="M12.7,41.3L11,40.9c-3.8-0.7-11-4-11-11.7c0-6.4,3.1-10,6.6-14.2c2.7-3.2,5.8-6.8,8.5-12.6L16.2,0l1.1,2.5c0.1,0.3,3,6.8,3.6,15.5c1.7-2.4,2.7-4.7,2.7-4.7l1.1-2.7l1.2,2.7c0.3,0.7,7.1,16.1,2.4,23.7c-1.7,2.7-4.5,4-8.4,4h-0.6L19,40.5c-2.8-3.7-4.8-8-5.8-12.5c-1.5,5-0.7,11.4-0.7,11.5L12.7,41.3L12.7,41.3z"
          {...pathProps}
        />
      </svg>
    )
  }
}

export default Fire
